import React, { useState, useEffect } from 'react'

import HoverTooltip from '../../../../../../components/HoverTooltip'
import MoneyInput from '../../../../../../components/form/MoneyInput'
import CurrencySelector from '../../../../../../components/currency/CurrencySelector'

import Section from '../../../../../../components/Section'
import { Contract, ContractPerformance } from '../../../types'

import { CurrencyList } from '../../types'

import Checkbox from '../../../../../../components/form/Checkbox'

import { PerformanceBaseInfoError } from '../types'

type Props = {
    theme: string
    perfAction: boolean
    contractGuid: string | undefined
    contractEndExecutionDate: string | null
    currencyList: CurrencyList[]
    contractPrice: number | undefined
    contractRubPrice: number | null | undefined
    performances: ContractPerformance[]
    performancesLoading: boolean
    performancesError: string | null
    performance: ContractPerformance
    onCompletedChange: (completed: boolean) => void
    isPenalty: boolean
    onPenaltyChange: (penalty: boolean) => void
    penaltyInfo: string | null
    onPenaltyInfoChange: (penalty_info: string) => void
    onCompletionStageEndDate: (completion_stage_end_date: string | null) => void
    errors?: PerformanceBaseInfoError
}

const formatNumber = (num: number | string | null | undefined): string => {
    if (num === null || num === undefined) return '-' // Обрабатываем пустые значения

    const parsedNum = typeof num === 'number' ? num : parseFloat(num)

    if (isNaN(parsedNum)) {
        return '-' // Обрабатываем некорректные значения
    }

    return parsedNum
        .toFixed(2) // Два знака после запятой
        .replace(/\B(?=(\d{3})+(?!\d))/g, ' ') // Разделяем тысячные пробелами
        .replace('.', ',') // Заменяем точку на запятую
}

const PerformanceBaseInfo: React.FC<Props> = (props) => {
    useEffect(() => {
        if (
            props.performance?.completion_stage_end_date == '' ||
            props.performance?.completion_stage_end_date == null
        ) {
            props.onCompletionStageEndDate(props.contractEndExecutionDate)
        }
    }, [props.contractEndExecutionDate])

    return (
        <Section title="Общая информация об исполнении договора">
            <fieldset disabled={props.perfAction}>
                <div className="flex flex-col w-full gap-x-5 space-y-3">
                    <div className="flex flex-col">
                        <label className="w-full mb-1 text-sm text-[#6A6A6A] dark:text-[#8A8A8A]">
                            Дата окончания исполнения договора (отдельного этапа
                            исполнения договора)
                        </label>
                        <HoverTooltip
                            tooltipText={
                                props.errors?.completion_stage_end_date || ''
                            }
                        >
                            <input
                                type="date"
                                className={`form-input user-input-placeholder w-[200px]  ${
                                    props.errors?.completion_stage_end_date
                                        ? 'border border-[#C15C5C] rounded-md p-2'
                                        : ''
                                }`}
                                value={
                                    props.performance
                                        ?.completion_stage_end_date ?? ''
                                }
                                onChange={(e) => {
                                    e.target.value == ''
                                        ? props.onCompletionStageEndDate(null)
                                        : props.onCompletionStageEndDate(
                                              e.target.value
                                          )
                                }}
                                style={{
                                    colorScheme:
                                        props.theme == 'dark'
                                            ? 'dark'
                                            : 'light',
                                }}
                            />
                        </HoverTooltip>
                    </div>
                    <div className="flex flex-col w-full gap-x-5 ">
                        <div className="flex flex-col min-w-[200px]">
                            <Checkbox
                                label="Исполнение договора завершено"
                                checked={props.performance?.completed ?? false}
                                onChange={props.onCompletedChange}
                                disabled={false}
                            />
                        </div>
                    </div>
                    <div className="flex flex-col w-full gap-x-5 ">
                        <div className="flex flex-col min-w-[200px]">
                            <Checkbox
                                label="В процессе исполнения договора были начислены неустойки (штрафы, пени)"
                                checked={props.isPenalty ?? false}
                                onChange={props.onPenaltyChange}
                                disabled={false}
                            />
                        </div>
                        {props.isPenalty && (
                            <div className="flex flex-col w-full ">
                                <label className="mt-2 mb-1 text-sm text-[#6A6A6A] dark:text-[#8A8A8A]">
                                    Информация о начислении неустоек (штрафов,
                                    пеней)
                                </label>
                                <HoverTooltip
                                    tooltipText={
                                        props.errors?.penalty_info || ''
                                    }
                                >
                                    <textarea
                                        className={`form-textarea ${
                                            props.errors?.penalty_info
                                                ? 'border border-[#C15C5C]'
                                                : ''
                                        }`}
                                        maxLength={2000}
                                        rows={3}
                                        value={props?.penaltyInfo || ''}
                                        onChange={(e) =>
                                            props.onPenaltyInfoChange(
                                                e.target.value
                                            )
                                        }
                                    />
                                </HoverTooltip>
                            </div>
                        )}
                    </div>
                </div>
            </fieldset>
        </Section>
    )
}

export default PerformanceBaseInfo
